import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function QualificationForm({ visitorId }) {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        companyName: "",
        address: "",
        city: "",
        postcode: "",
        companyNumber: "",
        industry: "",
        email: "",
        teamSize: "",
        website: "",
        interest: "",
        visitorId: visitorId || "",
    });
    const [status, setStatus] = useState("idle"); // idle | loading | success | error

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("loading");
        try {
            const res = await fetch("https://api.insightos.co.uk/leads/autoapproval", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            const data = await res.json();
            if (data.success === true) {
                setStatus("idle");
                navigate("/tos", {
                    state: {
                        email: form.email,
                        name: form.name,
                        companyName: form.companyName,
                    },
                });
            } else if (data.success === false) {
                setStatus("error");
            } else {
                setStatus("error");
            }
        } catch {
            setStatus("error");
        }
    };

    if (status === "loading") {
        return (
            <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-purple-100/85 via-sky-100/80 to-emerald-100/85">
                <div className="pointer-events-none absolute -left-24 -top-16 h-80 w-80 rounded-full bg-purple-500/20 blur-3xl" />
                <div className="pointer-events-none absolute -right-20 top-1/3 h-80 w-80 rounded-full bg-sky-500/20 blur-3xl" />
                <div className="pointer-events-none absolute bottom-0 left-1/3 h-80 w-80 rounded-full bg-emerald-500/20 blur-3xl" />
                <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4">
                    <img src="/avenor.png" alt="Avenor" className="mb-6 h-16 w-16 rounded-2xl border border-white/70 bg-white/80 p-2 sm:mb-8 sm:h-20 sm:w-20" />
                    <div className="w-full max-w-md rounded-2xl border border-white/55 bg-white/70 px-4 py-4 shadow-[0_24px_80px_rgba(37,99,235,0.2)] backdrop-blur-xl sm:px-6 sm:py-5">
                        <div className="flex items-center gap-3">
                            <svg className="h-8 w-8 animate-spin text-indigo-600" viewBox="0 0 24 24">
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                            fill="none"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        />
                            </svg>
                            <span className="text-base font-medium text-slate-700 sm:text-lg">Submitting qualification...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (status === "error") {
        return (
            <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-purple-100/85 via-sky-100/80 to-emerald-100/85 px-4">
                <div className="pointer-events-none absolute -left-24 -top-16 h-80 w-80 rounded-full bg-purple-500/20 blur-3xl" />
                <div className="pointer-events-none absolute -right-20 top-1/3 h-80 w-80 rounded-full bg-sky-500/20 blur-3xl" />
                <div className="pointer-events-none absolute bottom-0 left-1/3 h-80 w-80 rounded-full bg-emerald-500/20 blur-3xl" />
                <div className="relative z-10 flex min-h-screen flex-col items-center justify-center">
                    <div className="w-full max-w-2xl rounded-3xl border border-white/55 bg-white/70 p-5 text-center shadow-[0_24px_80px_rgba(37,99,235,0.2)] backdrop-blur-xl sm:p-8">
                        <img src="/avenor.png" alt="Avenor" className="mx-auto mb-5 h-16 w-16 rounded-xl border border-white/70 bg-white/80 p-2" />
                        <h1 className="mb-3 text-2xl font-bold text-red-600 sm:text-3xl">Qualification not approved at this time</h1>
                        <p className="text-sm text-slate-700 sm:text-base">
                            We currently could not approve this account under our B2B onboarding and compliance checks.
                            For help, contact{" "}
                            <a href="mailto:support@insightos.co.uk" className="font-semibold text-indigo-600 underline">
                                support@insightos.co.uk
                            </a>
                            .
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-purple-100/85 via-sky-100/80 to-emerald-100/85 text-slate-900">
            <div className="pointer-events-none absolute -left-24 -top-16 h-80 w-80 rounded-full bg-purple-500/20 blur-3xl" />
            <div className="pointer-events-none absolute -right-20 top-1/3 h-80 w-80 rounded-full bg-sky-500/20 blur-3xl" />
            <div className="pointer-events-none absolute bottom-0 left-1/3 h-80 w-80 rounded-full bg-emerald-500/20 blur-3xl" />

            <header className="sticky top-0 z-40 border-b border-white/45 bg-white/55 backdrop-blur-xl">
                <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
                    <div className="flex items-center gap-3">
                        <img src="/avenor.png" alt="Avenor" className="h-9 w-9 rounded-lg border border-white/70 bg-white/80 p-1" />
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-600">InsightOS</p>
                            <h1 className="text-base font-bold text-slate-900">Avenor</h1>
                        </div>
                    </div>
                    <nav className="flex items-center gap-2">
                        <Link to="/" className="rounded-lg border border-white/65 bg-white/75 px-4 py-2 text-sm font-semibold text-slate-800">
                            Home
                        </Link>
                        <Link to="/login" className="rounded-lg bg-gradient-to-r from-indigo-600 to-violet-600 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-500/30">
                            Login
                        </Link>
                    </nav>
                </div>
            </header>

            <main className="relative z-10 mx-auto w-full max-w-3xl px-4 pb-8 pt-6 sm:px-6 sm:pb-10 sm:pt-12">
                <form
                    onSubmit={handleSubmit}
                    className="w-full space-y-5 rounded-3xl border border-white/55 bg-white/70 p-5 shadow-[0_24px_80px_rgba(37,99,235,0.2)] backdrop-blur-xl sm:space-y-6 sm:p-8"
                >
                    <div className="flex flex-wrap items-center justify-between gap-3">
                        <h2 className="text-xl font-semibold text-slate-900 sm:text-2xl">Qualification Form</h2>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="rounded-lg border border-white/65 bg-white/75 px-4 py-2 text-sm font-semibold text-slate-800"
                        >
                            Back
                        </button>
                    </div>

                    <div className="rounded-xl border border-indigo-200 bg-indigo-50/90 px-4 py-3 text-sm text-indigo-900">
                        This is an individual license within a company and this is a personal account.
                    </div>

                    <div className="rounded-xl border border-sky-200 bg-sky-50/90 px-4 py-3 text-sm text-sky-900 leading-6">
                        Avenor is a B2B platform used for business outreach and company data workflows. We ask for qualification details to ensure responsible usage,
                        support compliance obligations, protect data handling standards, and maintain a trusted environment for all customers.
                    </div>

                <div className="grid gap-5 sm:grid-cols-2">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="name">
                        Name
                    </label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        required
                        value={form.name}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="companyName">
                        Company Name
                    </label>
                    <input
                        id="companyName"
                        name="companyName"
                        type="text"
                        required
                        value={form.companyName}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="address">
                        Address
                    </label>
                    <input
                        id="address"
                        name="address"
                        type="text"
                        required
                        value={form.address}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div className="grid gap-5 sm:grid-cols-2">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="city">
                        City
                    </label>
                    <input
                        id="city"
                        name="city"
                        type="text"
                        required
                        value={form.city}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="postcode">
                        Postcode
                    </label>
                    <input
                        id="postcode"
                        name="postcode"
                        type="text"
                        required
                        value={form.postcode}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="companyNumber">
                        Company Number
                    </label>
                    <input
                        id="companyNumber"
                        name="companyNumber"
                        type="text"
                        required
                        value={form.companyNumber}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="industry">
                        Industry
                    </label>
                    <input
                        id="industry"
                        name="industry"
                        type="text"
                        required
                        value={form.industry}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div className="grid gap-5 sm:grid-cols-2">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="email">
                        Email
                    </label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        value={form.email}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="teamSize">
                        Team Size
                    </label>
                    <input
                        id="teamSize"
                        name="teamSize"
                        type="number"
                        min="1"
                        required
                        value={form.teamSize}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="website">
                        Company Website
                    </label>
                    <input
                        id="website"
                        name="website"
                        type="url"
                        required
                        value={form.website}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="interest">
                        Why are you interested?
                    </label>
                    <textarea
                        id="interest"
                        name="interest"
                        rows={4}
                        required
                        value={form.interest}
                        onChange={handleChange}
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    />
                </div>
                <button
                    type="submit"
                    className="w-full rounded-lg bg-gradient-to-r from-indigo-600 to-violet-600 px-4 py-2.5 text-base font-semibold text-white shadow-lg shadow-indigo-500/30 hover:from-indigo-500 hover:to-violet-500 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-lg"
                >
                    Submit
                </button>
                </form>
            </main>
        </div>
    );
}
